import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { type Pagination, toQuery } from "@/api/pagination";
import { client } from "../client";

export const useAdminWorkspaces = (
  pagination: Pagination,
  sort: { column: "name" | "createdAt" | undefined; direction: "asc" | "desc" },
  { text }: { text?: string },
) => {
  return useQuery({
    queryKey: ["admin", "workspaces", pagination.limit, pagination.offset, sort.column, sort.direction, text],
    queryFn: async () => {
      const res = await client.admin.workspace.$get({ query: { ...toQuery(pagination), ...sort, text } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};

export const useAdminWorkspace = (id: string) => {
  return useQuery({
    queryKey: ["admin", "workspace", id],
    queryFn: async () => {
      const res = await client.admin.workspace[":id"].$get({ param: { id } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!id,
  });
};
